import { IEventrHireCar } from '@eventr/common'
import { HireCarHeader } from './hireCarComponents/hireCarHeader'
import { HireCarInfo } from './hireCarComponents/hireCarInfo'
import { ObjectProvider } from './providers/objectProvider'
import { BaseCard } from './subComponents/baseCard'

interface HireCarCardProps {
    id?: string
    data: IEventrHireCar
    past: boolean
    border?: boolean
}

export const HireCarCard = ({ id, data, past }: HireCarCardProps) => {
    return (
        <ObjectProvider past={past} _id={data._id} sectionID={'4'}>
            <BaseCard id={id} past={past}>
                <HireCarHeader
                    car_alias={data.car_alias}
                    label={data.label}
                    labelTime={data.labelTime}
                    pick_up={data.pick_up}
                />
                <HireCarInfo
                    pick_up={data.pick_up}
                    drop_off={data.drop_off}
                    pick_up_location={data.pick_up_location}
                    drop_off_location={data.drop_off_location}
                    booking_ref={data.booking_reference}
                    documents={data.extra_docs}
                    additional_info={data.comments}
                    passengers={data.passengers_list}
                    vehicle_type={data.vehicle_type}
                    provider={data.provider}
                    chatNames={[data.car_alias]}
                />
            </BaseCard>
        </ObjectProvider>
    )
}
